import Vue from 'vue'
import { mutationTypes } from './types'
import { Metadata } from '@/api'

export default {
  resetState: ({ commit }) => {
    commit(mutationTypes.RESET_STATE)
  },
  retrieveMetadata: async ({ commit }) => {
    commit(mutationTypes.METADATA_PENDING)
    try {
      const metadata = await Metadata.retrieveMetadata()
      commit(mutationTypes.METADATA_SUCCESS)
      commit(mutationTypes.SET_METADATA, metadata)
      return metadata
    } catch (err) {
      commit(mutationTypes.METADATA_FAILURE)
      throw err
    }
  }
}
